import WishlistRank from './WishlistRank'

export default WishlistRank
